export default __webpack_public_path__ + "static/media/008.7a14cd7e.jpg";